// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { createContext, useContext } from "react";

import { ResidentFlags } from "~@jii/data";
import { AnyStateSpecificData } from "~@jii/schemas";
import { JiiResidentAppRouterOutputs } from "~@jii/trpc-types";
import { useRequiredContext } from "~utils";

export type ResidentRecord = Omit<
  JiiResidentAppRouterOutputs["resident"]["getResident"],
  "stateSpecificData"
> & { stateSpecificData: AnyStateSpecificData | undefined };

export type SingleResidentContext = {
  resident: ResidentRecord;
  residentFlags: ResidentFlags;
};

const context = createContext<SingleResidentContext | undefined>(undefined);

export const SingleResidentContextProvider = context.Provider;

export function useSingleResidentContext() {
  return useRequiredContext(context);
}

export function useSingleResidentContextOptional() {
  return useContext(context);
}
